import { ColDef } from 'ag-grid-community';

const columnDefs: ColDef[] = [
  {
    field: 'name',
    headerName: 'Application Name',
    filter: 'agTextColumnFilter',
    initialWidth: 250,
  },
  {
    field: 'version',
    headerName: 'Version',
    filter: 'agTextColumnFilter',
    initialWidth: 250,
  },
];

export default columnDefs;
